import { IsString, MaxLength } from "class-validator";

export class TeamSearchDTO {
    
    @IsString()
    @MaxLength(50)
    name: string;

}
